import type { AdvisorWorkspaceProps } from '@/modules/advisorsPage/components/AdvisorWorkspace/AdvisorWorkspace.types'
import { AdvisorWorkspacePlaceholder } from '@/modules/advisorsPage/components/AdvisorWorkspacePlaceholder/AdvisorWorkspacePlaceholder'
import { AdvisorWorkspaceProfile } from '@/modules/advisorsPage/components/AdvisorWorkspaceProfile/AdvisorWorkspaceProfile'

import { Chat } from '@/components/@Shared/Chat/Chat'

export function AdvisorWorkspace({
  containerRef,
  isAdvisorAllowed,
  isChatOpen,
  isMutating,
  onChatClose,
  onChatOpen,
  onGrantAccess,
  onRevokeAccess,
  selectedAdvisor,
}: AdvisorWorkspaceProps) {
  if (!selectedAdvisor) {
    return <AdvisorWorkspacePlaceholder />
  }

  if (isChatOpen) {
    return (
      <Chat
        onChatClose={onChatClose}
        recipientId={selectedAdvisor.id}
        recipientImage={selectedAdvisor.avatar}
        recipientName={`${selectedAdvisor.firstName} ${selectedAdvisor.lastName}`}
      />
    )
  }

  return (
    <AdvisorWorkspaceProfile
      advisor={selectedAdvisor}
      containerRef={containerRef}
      isAdvisorAllowed={isAdvisorAllowed}
      isMutating={isMutating}
      onChatOpen={onChatOpen}
      onGrantAccess={onGrantAccess}
      onRevokeAccess={onRevokeAccess}
    />
  )
}
